<ion-header>
    <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">

  <iframe
    width="560"
    height="315"
    src="https://www.youtube.com/embed/g-JBcMUHE_c"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>

</ion-content>
